import React from 'react';
import { Link } from 'react-router-dom';

interface MemberProps {
  photo?: string;
  photoWithoutBackground?: string;
  name?: string;
  role?: string;
  linkedin?: string;
  years?: string;
}

const Member = ({ name, role, photo, years }: MemberProps) => {
  const id = name?.split(' ').join('-').toLowerCase();

  return (
    <Link
      to={{ pathname: `/member/${id}` }}
      className="member-card group relative block overflow-hidden rounded-xl bg-slate-800/50 border border-white/5 hover:border-white/15 transition-all duration-300 hover:shadow-lg hover:shadow-mainBlue/5"
    >
      <div className="relative aspect-[3/4] overflow-hidden">
        <img
          src={photo}
          alt={name || "Member photo"}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-slate-900/20 to-transparent opacity-60 group-hover:opacity-80 transition-opacity duration-300" />

        <div className="absolute bottom-0 left-0 right-0 p-3 md:p-4">
          <h2 className="text-white font-semibold text-sm md:text-base leading-tight mb-0.5 truncate">
            {name || "Unknown Member"}
          </h2>
          <p className="text-gray-400 text-xs md:text-sm truncate group-hover:text-gray-300 transition-colors">
            {role || "No Role"}
          </p>
          {years && (
            <p className="text-gray-500 text-[10px] md:text-xs mt-0.5 font-medium tracking-wide group-hover:text-gray-400 transition-colors">
              {years}
            </p>
          )}
        </div>

        <div className="absolute top-2 right-2 opacity-0 group-hover:opacity-100 transition-all duration-300 translate-y-1 group-hover:translate-y-0">
          <div className="w-7 h-7 rounded-full bg-mainBlue/80 backdrop-blur-sm flex items-center justify-center">
            <svg className="w-3.5 h-3.5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M13 7l5 5m0 0l-5 5m5-5H6" />
            </svg>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default Member;
